import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledCameraErrorContainer = styled.div`
  width: 460px;
	border: 3px solid black;
  margin: auto;
`;

export const StyledCameraErrorTitle = styled.h1`
	text-align: center;
	margin-top: 80px;
`;

export const StyledCameraErrorImage = styled.img`
  margin: auto;
  width: auto;
  height: 200px;
`;

export const StyledCameraErrorMessage = styled.p`
  text-align: center;
`;

export const StyledCameraErrorSectionButton = styled.div`
  margin: 20px auto 80px auto;
  width: 70%;
`;

interface StyledCameraErrorButtonProps {
  theme: any;
}
export const StyledCameraErrorButton = styled.button<StyledCameraErrorButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  word-break: break-word;
  background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  color: white;
  padding: 0.75rem;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: ${({ theme }) => pxToRem(theme.button_radius || 0)};
  box-shadow: none;
  transition: 0.2s cubic-bezier(0.25, 0.1, 0.25, 0.1);
  cursor: pointer;
  gap: 0.5rem;

  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: none;
    font-weight: 700;
    ${({ theme }) => theme.button_font && css`font-family: ${theme.button_font};`}
    width: 90%;
  }
  
  svg {
    font-size: 20px;
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;